import cookieStore from 'js-cookie';
import CryptoJS from 'crypto-js';

export const encryptData = (data: string): string => {
  const key = CryptoJS.enc.Utf8.parse('$%C*F-JaNdRgUkXp'); // Use a 16-byte key for AES-128
const iv = CryptoJS.enc.Utf8.parse('G+KbPeShVmYq3t6v');
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const decryptData = (encryptedData: string): string => {
  const key = CryptoJS.enc.Utf8.parse('$%C*F-JaNdRgUkXp'); // Use a 16-byte key for AES-128
  const iv = CryptoJS.enc.Utf8.parse('G+KbPeShVmYq3t6v');
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedText;
};

export const auth = {
  isAuthenticated: false,
  authenticate(cb = (): void => {}) {
    auth.isAuthenticated = !!cookieStore.get('accessToken');
    cb();
  },
  signout(cb = (): void => {}) {
    auth.isAuthenticated = false;
    cb();
  },
};

export const saveToLocal = (accessToken: any, data: any, history: any) => {
  cookieStore.set('accessToken', accessToken);
  localStorage.setItem('data', JSON.stringify(data));
  const isABHI = data?.providerDetail?.providerId === 516571;
  auth.authenticate();
  isABHI ?
    history.push('dashboard/insurer-report') :
    history.push('dashboard/claims-dashboard');
};
